import Playlist from "../views/playlistManagement/playlist";
import PlaylistSectionConfig from "../views/playlistManagement/playlistSectionConfig";
import PlaylistVideoList from "../views/playlistManagement/playlistVideoList";
import CollectionConfigList from "../views/playlistManagement/collectionConfigList";
import Main from "../views/main";

const PlaylistRouter = {
  path: "/playlist",
  component: Main,
  title: "合集管理",
  icon: "el-icon-video-camera-solid",
  meta: { keepAlive: true },
  children: [
    // {
    //   path: "/collectionConfigList",
    //   component: CollectionConfigList,
    //   name: "collectionConfigList",
    //   title: "合集模块列表",
    //   meta: { title: "合集模块列表", keepAlive: true },
    // },
    // {
    //   path: "/playlist-section-config",
    //   component: PlaylistSectionConfig,
    //   name: "playlistSectionConfig",
    //   title: "合集专题配置",
    //   meta: { title: "合集专题配置", keepAlive: true },
    // },
    {
      path: "/playlist",
      component: Playlist,
      name: "playlist",
      title: "合集列表",
      meta: { title: "合集列表", keepAlive: true },
    },
    {
      path: "/playlist-video-list",
      component: PlaylistVideoList,
      name: "playlistVideoList",
      title: "合集帖子列表",
      meta: { title: "合集帖子列表", keepAlive: true },
    },
  ],
};

export default PlaylistRouter;
